import React, { forwardRef } from 'react'
import { css, Paper as PaperBase, styled } from '@mui/material'
import { PALETTE_DICTIONARY } from '../Theme/Theme.utils'

export const Root = styled(
  forwardRef(({ color, elevation, enableBorder, enableHover, enableLine, height, margin, width, ...props }, ref) => (
    <PaperBase {...props} ref={ref} />
  ))
)`
  &.MuiPaper-root {
    background-color: ${({ color, theme }) => {
      if (color === 'blank') {
        return theme.palette.brand.white
      }

      return theme.palette[PALETTE_DICTIONARY[color]][95]
    }};
    border: ${({ color, enableBorder, theme }) => {
      if (!enableBorder) {
        return '0'
      }

      if (color === 'blank' || color === 'default') {
        return `1px solid ${theme.palette.gray[85]}`
      }

      return `1px solid ${theme.palette[PALETTE_DICTIONARY[color]][50]}`
    }};
    border-radius: 4px;
    box-shadow: ${({ elevation, theme }) => {
      switch (elevation) {
        case '1': {
          return `0 4px 8px 0 ${theme.palette.gray[85]}`
        }
        case '2': {
          return `0 6px 14px 0 ${theme.palette.gray[85]}`
        }
        case '3': {
          return `0 10px 24px 0 ${theme.palette.gray[85]}`
        }
        case '4': {
          return `0 16px 28px 0 ${theme.palette.gray[85]}`
        }
        default: {
          return 'none'
        }
      }
    }};
    box-sizing: border-box;
    height: ${props => props.height};
    margin: ${props => props.margin};
    padding: ${props => (props.enableLine ? '0 0 0 7px' : '0')};
    position: relative;
    width: ${props => props.width};

    ${({ enableHover }) =>
      enableHover &&
      css`
        &:hover {
          box-shadow: ${({ elevation, theme }) => {
            switch (parseInt(elevation) + 1) {
              case 1: {
                return `0 4px 8px 0 ${theme.palette.gray[85]}`
              }
              case 2: {
                return `0 6px 14px 0 ${theme.palette.gray[85]}`
              }
              case 3: {
                return `0 10px 24px 0 ${theme.palette.gray[85]}`
              }
              case 4: {
                return `0 16px 28px 0 ${theme.palette.gray[85]}`
              }
              case 5: {
                return `0 22px 28px 0 ${theme.palette.gray[85]}`
              }
              default: {
                return 'none'
              }
            }
          }};
        }
      `}
  }
`

export const Line = styled(({ color, ...props }) => <div {...props} />)`
  background-color: ${({ color, theme }) => theme.palette[PALETTE_DICTIONARY[color]][50]};
  border-bottom-left-radius: 3.5px;
  border-top-left-radius: 3.5px;
  bottom: 0;
  left: 0;
  position: absolute;
  top: 0;
  width: 7px;
`

export const Content = styled(({ padding, ...props }) => <div {...props} />)`
  box-sizing: border-box;
  color: ${props => props.theme.palette.gray[20]};
  font-family: ${props => props.theme.typography.fontFamily};
  padding: ${props => props.padding};
  width: 100%;
`
